"use client";

import { BackButton } from "@/components/back-button";
import { Button } from "@/components/ui/button";
import { Home, Info } from "lucide-react";
import Link from "next/link";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error("Error caught:", error);
  }, [error]);
  return (
    <section className="-top-[84px] -mb-[84px] font-outfit bg-primary-900 w-full overflow-hidden relative before:content-[''] before:absolute before:left-0 before:-top-20 before:w-1/2 before:h-full before:bg-[url('/index/hero/right.svg')] before:bg-no-repeat before:bg-cover before:transform before:-scale-x-100 after:content-[''] after:absolute after:right-0 after:-top-20 after:w-1/2 after:h-full after:bg-[url('/index/hero/right.svg')] after:bg-no-repeat after:bg-cover">

      <div className="max-w-screen-2xl mx-auto overflow-hidden z-[2] relative before:absolute before:content-[''] before:w-full before:h-full before:bg-[url('/index/hero/center.svg')] before:bg-contain before:bg-center before:bg-no-repeat pt-[130px] sm:pt-[140px] before:top-0 min-h-screen  lg:flex lg:flex-col lg:justify-center">
        <div className="relative grid items-center justify-center text-primary-text-50 max-w-screen-2xl mx-auto gap-8 px-6 text-center py-20">
          <div className="bg-white flex items-center justify-center rounded-full w-24 h-24 mx-auto">
            <Info
              className="rotate-180 text-secondary-500"
              width={48}
              height={48}
            />
          </div>
          <div className="space-y-6">
            <h1 className="text-8xl sm:text-9xl font-bold tracking-tight">
              Oops!
            </h1>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
              Something went wrong
            </h2>
            <p className="text-lg sm:text-xl text-primary-text-50 max-w-xl mx-auto leading-relaxed">
              We&apos;re experiencing a temporary hiccup. Don&apos;t worry, our
              team is on it! Please try refreshing the page or come back in a
              few moments.
            </p>
          </div>

          <div className="flex flex-row gap-4 justify-center items-center mt-4 w-full flex-wrap">
            <Button asChild size="lg" variant={"outline"}>
              <Link href="/">
                <Home />
                Back to Home
              </Link>
            </Button>
            <BackButton variant="outline" onClick={reset}>
              Try Again
            </BackButton>
          </div>

          <p className="text-base text-primary-text-50 mt-8">
            Need help?{" "}
            <Link
              href="/contact-us"
              className="underline underline-offset-4 hover:text-primary-text-50 transition-colors font-medium"
            >
              Contact support
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}
